import script from "./SectionVictory.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionVictory.vue?vue&type=script&setup=true&lang=js"

import "./SectionVictory.vue?vue&type=style&index=0&id=56f8d65c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f8d65c"]])

export default __exports__